import styled from "styled-components";

const Container = ({ children }: any) => {
  return <StyledContainer>{children}</StyledContainer>;
};

export default Container;

const StyledContainer = styled.div`
  padding: 40px;
  background-color: #ffffff;
  // &:hover {
  //   background-color: #f3f3f3;
  // }
  position: relative;
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
`;
